import { useState, useRef, useEffect } from "react"
import { SurveyDetailsView } from "../../views"
import { CatalogService, LocalStorageService, SurveyService } from "../../../services"
import { SimpleLoading, ModalUtil } from "../../pures"
import { useLocation, useHistory } from "react-router-dom"
import { useTranslation } from 'react-i18next'

const SurveyDetailsAction = () => {
  const { t: transl } = useTranslation('publicity', { keyPrefix: 'modal' });
  const { t } = useTranslation()
  const [initialLoading, setInitialLoading] = useState(true)
  const [publicityData, setPublicityData] = useState({})
  const [catalogInsert, setCatalogInsert] = useState([])

  const location = useLocation()
  const queryParameters = new URLSearchParams(location.search)
  const surveyId = queryParameters.get('surveyId')

  const url = process.env.REACT_APP_ETICKET_API
  const localStorageService = new LocalStorageService()
  const surveyService = new SurveyService(url)
  const modalUtil = new ModalUtil()
  const history = useHistory()
  const catalogService = new CatalogService(url)

  useEffect(() => {
    if (surveyId) {
      // execute function that retrieve the information
      getPublicityInformation()
      getCatalogInsert()
    }
  }, [])

  const getCatalogInsert = async () => {
    const token = localStorageService.getLocalStorageItem('token').accessToken
    const catalogInsert = await catalogService.getCatalogInsert(token, 'survey')
    setCatalogInsert(catalogInsert)

  }

  const getPublicityInformation = async () => {
    try {
      const token = localStorageService.getLocalStorageItem('token').accessToken
      const surveyDetails = await surveyService.getSurveyDetailsById(surveyId, token)

      const { questions } = surveyDetails

      for (let key in questions) {
        let question = questions[key]

        question.edit = false

        question.questionOptions = question.questionOptions.length > 0 && question.questionOptions.map((questionOption) => {
          return questionOption?.name
        })
      }

      // Showing the variables here
      setPublicityData(surveyDetails)
      setInitialLoading(false)
    } catch (error) {
      console.log(error)
      modalUtil.showModal('error', transl('errorUpload'), t("modal.pure.title.error"))
      setInitialLoading(false)
    }
  }

  const handleReturn = (route) => {
    history.push(route)
  }

  const goToAnswers = () => {
    history.push(`/survey-answers/${surveyId}`)
  }

  return (
    <>
      {
        initialLoading ?
          <div className="loading">
            <SimpleLoading />
          </div> :
          <SurveyDetailsView
            publicityData={publicityData}
            publicityId={surveyId}
            handleReturn={handleReturn}
            typeQuestion={catalogInsert.typeQuestion}
            goToAnswers={goToAnswers}
          />
      }
    </>
  )
}

export default SurveyDetailsAction